
import { Model } from 'backbone';

class ToolboxPaneModel extends Model {

    initialize() {
    }

    defaults() {
        return {};
    }
}

export default ToolboxPaneModel;
